import React from 'react';

export default class Footer extends React.Component {
  render() {
    return(
      <footer>
        <div className='footer-copy hidden-on-mobile'>
          &copy; { (new Date()).getFullYear() } Yak Tack, LLC &middot; <a href="https://yaktack.substack.com/" rel='noopener noreferrer' target="_blank">Newsletter</a> &middot; <a href='/privacy'>Privacy</a> &middot; <a href='/terms_of_service'>Terms</a> &middot; <a href="mailto:hello@yaktack.com" rel='noopener noreferrer' target="_blank">Email</a>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.jsx